<template>
	<div
		v-if="is_view"
		class="quick"
	>
		<ul class="text-center">
			<li>
				<button @click="toCall">
				</button>
			</li>
			<li>
				<button  @click="toQna">
				</button>
			</li>
			<li>
				<button @click="toPdt">
				</button>
			</li>
			<li>
				<button @click="toTop">
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'Quick'
		, props: ['user']
		, data: function(){
			return {

			}
		}

		, computed: {
			is_view: function(){
				let t = true
				if(this.$route.path.indexOf('Auth') > -1){
					t = false
				}
				return t
			}
		}
		, methods: {
			toTop: function(){
				document.body.scrollTo({
					top: 0, behavior: 'smooth'
				})
			}
			, toQna: function(){
				if(this.user.member_level > 0){
					this.$bus.$emit('to', {name: 'CustomerCenter', params: { b_code: 'b_qna' }})
				}else{
					this.$bus.$emit('notify', { type: 'error', message: '회원전용입니다'});
				}
			}
			, toCall: function(){
				this.$bus.$emit('to', {name: 'CustomerCenter', params: { b_code: 'b_notice' }})
			}
			, toPdt: function(){
				if(this.user.member_level > 1){
					this.$bus.$emit('to', {name: 'ProductList', params: { pdt_div: 'mobile' }})
				}else{
					this.$bus.$emit('to', {name: 'ProductList', params: {  }})
				}
			}
		}
		, created() {
		}
	}
</script>

<style>
	.quick {
		position: fixed;
		bottom: 29px; right: calc(50% - 730px);
		z-index: 998;
	}
</style>